import { ScrollView, YStack, type YStackProps } from 'tamagui';

export interface ScreenProps extends YStackProps {
  /** Wrap children in a ScrollView so long content scrolls on mobile. Default: false. */
  scrollable?: boolean;
}

/**
 * Top-level container for a single "screen" or page. Provides consistent
 * padding, vertical gap, and a brand-themed background. Use as the root of
 * each route on web and each screen on mobile.
 */
export function Screen({ children, scrollable, ...rest }: ScreenProps) {
  if (scrollable) {
    return (
      <ScrollView
        flex={1}
        backgroundColor="$background"
        contentContainerStyle={{ padding: 16, gap: 16 }}
        keyboardShouldPersistTaps="handled"
      >
        <YStack gap="$4" {...rest}>
          {children}
        </YStack>
      </ScrollView>
    );
  }
  return (
    <YStack flex={1} padding="$4" gap="$4" backgroundColor="$background" {...rest}>
      {children}
    </YStack>
  );
}
